import { Routes } from '@angular/router';

import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    loadComponent: () => import('./layout').then(m => m.DefaultLayoutComponent),
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'almacen',
        loadChildren: () => import('./views/almacen/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'entrada',
        loadChildren: () => import('./views/entrada/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'salida',
        loadChildren: () => import('./views/salida/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes),
        canActivate: [authGuard]
      },
      {
        path: 'productos',
        loadChildren: () => import('./views/productos/routes').then(m => m.routes),
        canActivate: [authGuard]

      },

      {
        path: 'users',
        loadChildren: () => import('./views/users/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'documentos',
        loadChildren: () => import('./views/documento/routes').then((m) => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'roles',
        loadChildren: () => import('./views/roles-permisos/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'servicios',
        loadChildren: () => import('./views/cat-servicios/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'inventario',
        loadChildren: () => import('./views/inventario/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'cobro-detalle-tarima',
        loadChildren: () => import('./views/cobro-detalle-tarima/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
        {
        path: 'legal',
        loadChildren: () => import('./views/legal-tabs/routes').then(m => m.routes),
        canActivate: [authGuard]

      },
      {
        path: 'facturacion',
        loadChildren: () => import('./views/facturacion/routes').then(m => m.routes),
        canActivate: [authGuard]
      },
      {
        path: 'trazabilidad',
        loadChildren: () => import('./views/trazabilidad/routes').then(m => m.routes),
        canActivate: [authGuard]
      },
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    canActivate: [loginGuard],
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  },
  { path: '**', redirectTo: 'dashboard' }
];
